import QRCode from 'qrcode'

export default function (url) {
  return new Promise((resolve, reject) => {
    QRCode.toDataURL(url, (error, imgSrc) => {
      if (error) {
        reject(error)
      }
      resolve(imgSrc)
    })
  })
}
